import {DB} from '@/store/kysely_types';
import {Kysely} from 'kysely';
import {DBObjects} from '@/store/store_types';

type Props = {
    db: Kysely<DB>;
    getFileSrc: (file: DBObjects['File'] & {full_path?: string}) => Promise<string>;
}

export default async function (props: Props) {
    await runMigration(props);
}

const runMigration = async (props: Props) => {
    const db = props.db;

    const users = await db.selectFrom('User')
        .selectAll()
        .execute();

    for (const user of users) {
        const existingWorkspace = await db.selectFrom('Workspace')
            .select('id')
            .where('id', '=', user.id)
            .executeTakeFirst();

        if (existingWorkspace) {
            continue;
        }

        await db.insertInto('Workspace')
            .values({
                id: user.id,
                name: `${user.name || 'User'}'s User Workspace`,
                owner_id: user.id,
                created_by: user.id,
                type: 'USER',
            })
            .execute();

        console.log(`Created USER workspace for user ${user.id} (${user.name})`);
    }

    console.log(`Data migration complete: Created USER workspaces for ${users.length} users`);
};
